import React from "react";

type SectionDescriptionProps = {
  title: string;
  description?: string;
};

export const SectionDescription: React.FC<SectionDescriptionProps> = ({
  title,
  description,
}) => (
  <div className="flex items-stretch gap-4">
    <div className="w-px shrink-0 rounded-[1px] bg-[#E0E0E0]" />
    <div className="flex max-w-[600px] flex-col gap-1">
      <span className="text-dark font-secondary font-medium">{title}</span>
      {description && (
        <span className="text-dark-600 font-secondary text-[13px]">
          {description}
        </span>
      )}
    </div>
  </div>
);
